import { matchRoutes, useLocation } from 'react-router-dom'
import routes from '../routes'

/** Para usar este hook é necessário estar dentro de uma das rotas do arquivo routes.js */
const useCurrentPath = (): string => {
    const location = useLocation()
    const matchedRoute = matchRoutes(routes, location) || []

    return matchedRoute[0].route.path || ''
}

export default useCurrentPath
